module.exports = __webpack_public_path__ + "img/person-dots-from-line.8e20fc0e.svg";